import { OrganizationOwnerV2 } from '../types/organization';

/**
 * Human-readable label for an organization owner / owner candidate:
 * email first, then phone, then the raw id, then a dash placeholder.
 */
export function formatOwnerLabel(
  owner: OrganizationOwnerV2 | null | undefined,
): string {
  if (!owner) {
    return '-';
  }
  return owner.email || owner.phone || owner.id || '-';
}
